var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.ads),function(add){return _c('div',{key:add.id},[_c('div',{domProps:{"innerHTML":_vm._s(add.adcode)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }